import React from 'react';
import { makeStyles, tokens, Button, Subtitle1, Divider } from '@fluentui/react-components';
import { AdditionalSupportConfig } from '../types';
import { MarkdownBody, isSafeUrl } from './MarkdownBody';

const useStyles = makeStyles({
  buttonContainer: {
    marginTop: tokens.spacingVerticalM,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: '100%',
  },
});

interface AdditionalSupportSectionProps {
  config: AdditionalSupportConfig;
}

/**
 * Per-tenant "Additional Support" block (e.g. EAP details). Rendered only when
 * the backend org config provides it; heading/body are required, the button is
 * optional and only shown when both a label and a safe URL are configured.
 */
export const AdditionalSupportSection: React.FC<AdditionalSupportSectionProps> = ({ config }) => {
  const styles = useStyles();
  const { heading, body, button } = config;

  if (!heading || !body) {
    return null;
  }

  const showButton = Boolean(button?.label && button?.url && isSafeUrl(button.url));

  return (
    <>
      <Subtitle1 style={{ marginTop: 15 }}>{heading}</Subtitle1>
      <MarkdownBody>{body}</MarkdownBody>
      {showButton && (
        <div className={styles.buttonContainer}>
          <Button
            appearance="primary"
            as="a"
            href={button?.url}
            target="_blank"
            rel="noreferrer"
          >
            {button?.label}
          </Button>
        </div>
      )}
      <br />
      <Divider />
    </>
  );
};
